import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';

import { DropdownItemComponent } from '../../../../common/dropdown/dropdown-item/dropdown-item.component';
import { IconComponent } from '../../../../common/icon/icon.component';
import { Select2FooterDirective } from './footer.directive';

@Component({
  selector: 'rt-select-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Select2FooterDirective, DropdownItemComponent, IconComponent],
  template: `
    <ng-template rtSelectFooter>
      <ng-content />
    </ng-template>
  `,
  providers: [
    {
      provide: Select2FooterDirective,
      useFactory: () => inject(FooterDefaultComponent).directive,
    },
  ],
})
export class FooterDefaultComponent {
  @ViewChild(Select2FooterDirective, { static: true })
  public directive: Select2FooterDirective;
}
